export default __webpack_public_path__ + "static/8-ca0cc1a3c6a795eabda7a3b947257307.jpg";